import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "./motion";

const STEPS = [
  ["01", "Log in", "Use the email and password from the GAMEDAY mobile app. No new account, no new database."],
  ["02", "Land in the right seat", "Coaches and players open the team dashboard. Recruiters open their scouting board."],
  ["03", "Print the story", "Player reports, box scores and dossiers print cleanly straight from your browser."],
];

export const Steps = () => (
  <section id="how" className="relative scroll-mt-20 border-t border-white/5 bg-[#0F172A]/60">
    <div className="mx-auto max-w-[1400px] px-5 py-28 sm:px-10 sm:py-36">
      <Reveal><h2 className="mb-16 font-display text-5xl font-black uppercase leading-[0.9] text-white sm:text-7xl">Three possessions<br /><span className="text-slate-500">to tip-off.</span></h2></Reveal>
      <div className="grid gap-px overflow-hidden rounded-3xl bg-white/5 md:grid-cols-3">
        {STEPS.map(([n, t, d], i) => (
          <Reveal key={n} delay={i * 0.1} className="h-full">
            <div className="group h-full bg-[#0A0E1A] p-8 transition-colors duration-500 hover:bg-[#0F172A] sm:p-10">
              <p className="font-mono-gd text-6xl font-bold text-[#1E293B] transition-colors duration-500 group-hover:text-[#39FF14]">{n}</p>
              <h3 className="mt-10 font-display text-3xl font-extrabold uppercase text-white">{t}</h3>
              <p className="mt-3 text-slate-400">{d}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export const FinalCta = () => (
  <section className="relative overflow-hidden">
    <img src="/img/hero.jpg" alt="Packed gym during a high school game" className="absolute inset-0 h-full w-full object-cover grayscale" />
    <div className="absolute inset-0 bg-[#0A0E1A]/80" />
    <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_120%,rgba(57,255,20,0.25),transparent_60%)]" />
    <div className="relative mx-auto max-w-[1400px] px-5 py-32 text-left sm:px-10 sm:py-44">
      <Reveal>
        <p className="font-mono-gd text-xs uppercase tracking-[0.3em] text-[#39FF14]">Your season is already in here</p>
        <h2 className="mt-6 font-display text-6xl font-black uppercase leading-[0.85] text-white sm:text-8xl lg:text-[9rem]">Step on<br />the court.</h2>
        <Link to="/login" data-testid="cta-login-button" className="group mt-12 inline-flex items-center gap-3 rounded-full bg-[#39FF14] py-4 pl-8 pr-4 text-lg font-bold text-[#0A0E1A] transition-[box-shadow] hover:shadow-[0_0_60px_rgba(57,255,20,0.55)]">
          Log in to Courtside
          <span className="flex h-10 w-10 items-center justify-center rounded-full bg-[#0A0E1A] text-[#39FF14] transition-transform duration-300 group-hover:rotate-[-45deg]"><ArrowRight className="h-5 w-5" /></span>
        </Link>
        <Link to="/join" data-testid="cta-join-link" className="mt-6 block w-fit font-semibold text-white underline decoration-[#39FF14] underline-offset-4 hover:text-[#39FF14] sm:ml-6 sm:mt-0 sm:inline-block">New here? Join now</Link>
      </Reveal>
    </div>
  </section>
);

export const Footer = () => (
  <footer className="border-t border-white/5 bg-[#0A0E1A]">
    <div className="mx-auto flex max-w-[1400px] flex-col gap-6 px-5 py-10 sm:px-10 lg:flex-row lg:items-center lg:justify-between">
      <div className="flex items-start gap-3">
        <img src="/logo-mark.png" alt="GAMEDAY" className="h-8 w-auto" />
        <div>
          <p data-testid="footer-brand" className="text-sm text-slate-300">GAMEDAY Courtside by HoopsHQ. <span className="text-slate-400">HoopsHQ.net is the home of GAMEDAY Courtside, the web side of the GAMEDAY mobile app.</span></p>
          <p className="mt-1 text-sm text-slate-400">© {new Date().getFullYear()} GAMEDAY Holdings LLC</p>
        </div>
      </div>
      <nav className="flex flex-wrap gap-x-6 gap-y-2 text-sm">
        <Link to="/demo" data-testid="footer-demo-link" className="text-slate-300 hover:text-[#39FF14]">Sample team</Link>
        <Link to="/demo/players/demo-p1" data-testid="footer-demo-player-link" className="text-slate-300 hover:text-[#39FF14]">Sample player report</Link>
        <Link to="/demo/recruiter" data-testid="footer-demo-recruiter-link" className="text-slate-300 hover:text-[#39FF14]">Sample recruiter board</Link>
        <Link to="/visibility" data-testid="footer-visibility-link" className="text-slate-300 hover:text-[#39FF14]">Who sees what</Link>
      </nav>
    </div>
  </footer>
);
